import React, { Fragment, useState } from "react";
import Avatar from "@components/avatar";
import { Badge } from "reactstrap";
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useTranslation } from "react-i18next";
import { useGetTotalTaskDueDateByNotification } from "../../../../../views/dashboard/private-dashboard/Api";
import {
  momentFormat,
  typeLayout,
} from "../../../../../views/apps/ecommerce/utils/utils";

const OverdueTasks = () => {
  const { t } = useTranslation();
  const [pages, setPages] = useState(1);
  const dark = typeLayout();
  const moment_format = momentFormat();
  const {
    data: dataTaskDueDate,
    isLoading: isLoadingTaskDueDate,
    isPreviousData,
  } = useGetTotalTaskDueDateByNotification(pages);

  return (
    <>
      <RenderNotificationItems data={dataTaskDueDate} />
    </>
  );
};
const RenderNotificationItems = ({ data }) => {
  return (
    <PerfectScrollbar
      component="li"
      className="media-list scrollable-container"
      options={{
        wheelPropagation: false,
      }}
    >
      <div>
        {data?.data?.map((it, index) => {
          return (
            <a
              key={index}
              className="d-flex"
              href={`/apps/work/tasks/${it?.id}`}
              target="blank"
            >
              <div
                className={classnames("list-item d-flex notification-common")}
              >
                <Fragment>
                  <div className="me-1">
                    <Avatar img={it?.assigned_to?.[0]?.image_url} />
                  </div>
                  <div className="list-item-body flex-grow-1">
                    {it?.assigned_to?.[0]?.name}{" "}
                    <Badge color="light-danger">{it?.status}</Badge>
                    <br />
                    <small
                      className="notification-text"
                      style={{ color: "#7D7B89" }}
                    >
                      {it?.heading}
                    </small>
                  </div>
                </Fragment>
              </div>
            </a>
          );
        })}
      </div>
    </PerfectScrollbar>
  );
};
export default OverdueTasks;
